import { render } from "./NetworkGate.vue?vue&type=template&id=bb289cf0&ts=true"
import script from "./NetworkGate.vue?vue&type=script&lang=ts"
export * from "./NetworkGate.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/isamu/ss/web3/laidbacklu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__